
var React = require("react");
var ActionButton = require("../generic/ActionButton.jsx");
var ObservableUtil = require("../../../util/ObservableUtil.js");
var DataActionUtil = require("../../../util/DataActionUtil.js");
let LoadingCard = require("../../cards/LoadingPlaceholder.jsx");

class PublicPrivateButton extends React.Component  {
    constructor(){
        super()

        // publish stores its own isPrivate so that we can make the button change
        // instantly, even before the resource update happens
        this.state = {isLoading: false, isPrivate: false}

        this.setLoad = this.setLoad.bind(this);
        this.statusChanged = this.statusChanged.bind(this);
    }

    componentDidMount(){
        this.setState({isPrivate: this.props.resource.private});

    // since the publish button actually switches its state right away (before it knows if publishing was successful or not)
    // it needs to subscribe to the publish change, because if there was an error it needs to set its state back to what it should be.
        ObservableUtil.subscribeToChange("publish", this.props.resource.id, "publicPrivateButton", (response, isError) => this.statusChanged(response, isError))
    }

    componentWillUnmount() {
        ObservableUtil.unsubscribeToChange("publish", this.props.resource.id, "publicPrivateButton");
    }

    statusChanged(response, isError){
        if(isError){
            // we guessed this would succeed (flip on press) so set it back to what it should be
            this.setState({isPrivate: this.props.resource.private});
        } else {
            // set correctly (can probably do nothing here, but just to be safe)
            if(response.message == "published"){
                this.setState({isPrivate: false});
            } else if(response.message == "unpublished") {
                this.setState({isPrivate: true});
            }
        }
    }

    setLoad(isLoading){
        this.setState({isLoading});
    }


    render(){
        // we have a second private bool so that we can flip it and see the change immediately.
        const {isLoading, isPrivate} = this.state;
        const {permissions} = this.props.resource;

        if(isLoading){
            return <div className="button">
                <div className={`infoLibrary__options__public`}>
                    <LoadingCard/>
                </div>
            </div>
        } else {
            return <ActionButton 
                    {...this.props}
                    text={(isPrivate)?"Make Public":"Make Private"}
                    mainClass={(isPrivate)?"button blue responsible-library-info":"button responsible-library-info"}
                    removeDisable={!permissions.includes("publish resource")}
                    action={(resource, setConfirmation, setLoading, setError) => {
                        if(this.props.resource.private){
                            DataActionUtil.publishAsset(resource, setConfirmation, this.setLoad, setError)
                        } else {
                            DataActionUtil.unpublishAsset(resource, setConfirmation, this.setLoad, setError)
                        }

                        // switch the state right away to avoid the quarter second delay of the resource update 
                        // (this delay can be seen when looking at the public/private icon)
                        this.setState({isPrivate: !this.props.resource.isPrivate});
                    }}
               />
        }
    }
}

module.exports = PublicPrivateButton;